require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./die-ersten-waende-sind-da.json") })
        }
      }, "path---die-ersten-waende-sind-da");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---die-ersten-waende-sind-da!./.cache/json/die-ersten-waende-sind-da.json
// module id = 415
// module chunks = 231608221292675